import {
  faUser,
  faUsers,
  faBox,
  faTruck,
  faExchangeAlt,
  faFileContract,
  faClipboard,
  faBuilding,
  faUserFriends,
  faBriefcase,
  faDashboard,
  faCircleArrowRight,
  faBoxes,
  faPieChart,
  faToolbox,
  faDeleteLeft,
  faBarcode,
  faTruckFast,
  faChartBar,
} from '@fortawesome/free-solid-svg-icons'

export const sectionAluguelAdmin = [
  {
    title: 'Dashboard',
    icon: faDashboard,
    to: '/dashboard',
    requiredPermission: 'Listar dashboard do admin',
  },
  {
    title: 'Administração',
    icon: faUserFriends,
    opened: true,
    items: [
      {
        name: 'Usuários',
        icon: faUserFriends,
        to: '/aluguel/usuarios',
        requiredPermission: 'Listar usuários',
      },
      {
        name: 'Cargos',
        icon: faBriefcase,
        to: '/aluguel/cargos',
        requiredPermission: 'Listar cargos',
      },
      {
        name: 'Organizações',
        icon: faBuilding,
        to: '/aluguel/organizacoes/dashboard',
        requiredPermission: 'Listar organizações',
      },
      {
        name: 'Logs do sistema',
        icon: faClipboard,
        to: '/aluguel/logs',
        requiredPermission: 'Listar logs',
      },
    ],
  },
  {
    title: 'Relatórios',
    icon: faPieChart,
    items: [
      {
        name: 'Relatórios de logs',
        icon: faClipboard,
        to: '/aluguel/relatorios/logs',
        requiredPermission: 'Listar logs',
      },
    ],
  },
]

export const sectionsAluguel = (user) => {
  // 🛡️ PROTEÇÃO: Se 'user' for null/undefined no carregamento inicial, usa um fallback seguro
  const safeUserId = user?.id || 'meu-perfil'

  return [
    {
      title: 'Dashboard',
      icon: faDashboard,
      to: '/dashboard',
      requiredPermission: 'Listar dashboard de aluguel',
    },
    {
      title: 'Usuário',
      icon: faUser,
      items: [
        {
          name: 'Perfil',
          icon: faUser,
          to: `/aluguel/usuarios/perfil/${safeUserId}`,
          requiredPermission: '',
        },
      ],
    },
    {
      title: 'Clientes',
      icon: faUsers,
      items: [
        {
          name: 'Clientes',
          icon: faUsers,
          to: '/aluguel/clientes',
          requiredPermission: 'Listar clientes',
        },
      ],
    },
    {
      title: 'Equipamentos',
      icon: faBox,
      items: [
        {
          name: 'Equipamentos',
          icon: faBox,
          to: '/aluguel/equipamentos',
          requiredPermission: 'Listar equipamentos',
        },
        {
          name: 'Aguardando baixa',
          icon: faDeleteLeft,
          to: '/aluguel/equipamentos-para-baixa',
          requiredPermission: 'Excluir equipamentos',
        },
        {
          name: 'Escanear',
          icon: faBarcode,
          to: '/aluguel/escanear-equipamentos',
          // * Permissão usada somente para Admin, expedição e logistica
          requiredPermission: 'Listar devoluções confirmadas',
        },
        {
          name: 'Retombo',
          icon: faCircleArrowRight,
          to: '/aluguel/equipamentos/corrigir-tombo',
          requiredPermission: 'Listar equipamentos',
        },
        {
          name: 'Fornecedores',
          icon: faTruck,
          to: '/aluguel/fornecedores',
          requiredPermission: 'Listar fornecedores',
        },
        // {
        //   name: "Unidades",
        //   icon: faRuler,
        //   to: "/aluguel/unidades",
        //   requiredPermission: "Listar unidades de medida",
        // },
        // {
        //   name: "Kits",
        //   icon: faBoxOpen,
        //   to: "/aluguel/kits-equipamentos",
        //   requiredPermission: "Listar kits",
        // },
      ],
    },
    {
      title: 'Movimentos',
      icon: faExchangeAlt,
      items: [
        {
          name: 'Movimentos',
          icon: faExchangeAlt,
          to: '/aluguel/movimentos',
          requiredPermission: 'Listar movimentos',
        },
        {
          name: 'Carregamentos',
          icon: faTruck,
          to: '/aluguel/carregamentos',
          requiredPermission: 'Listar carregamentos',
        },
      ],
    },
    {
      title: 'Contratos',
      icon: faFileContract,
      items: [
        {
          name: 'Contratos',
          icon: faFileContract,
          to: '/aluguel/contratos/',
          requiredPermission: 'Listar contratos',
        },
        {
          name: 'Relatórios',
          icon: faChartBar,
          to: `/aluguel/relatorio/contratos`,
          requiredPermission: 'Listar relatórios',
        },
      ],
    },
    {
      title: 'Requisições',
      icon: faClipboard,
      items: [
        {
          name: 'Requisições',
          icon: faClipboard,
          to: '/aluguel/requisicoes',
          requiredPermission: 'Listar ordens de serviço',
        },
      ],
    },
    {
      title: 'Relatórios',
      icon: faUser,
      items: [
        {
          name: 'Equipamentos por Situação', // * Ajuste a pedido de Dona Delne
          icon: faBoxes,
          to: `/aluguel/relatorio/equipamentos-em-estoque`,
          requiredPermission: 'Listar relatórios',
        },
        {
          name: 'Equipamentos por contrato',
          icon: faUser,
          to: `/aluguel/relatorio/equipamentos-por-contrato`,
          requiredPermission: 'Listar relatórios',
        },
        {
          name: 'Equipamentos por cliente',
          icon: faUser,
          to: `/aluguel/relatorio/equipamentos-por-cliente`,
          requiredPermission: 'Listar relatórios',
        },
        {
          name: 'Relatorio Logístico',
          icon: faTruckFast,
          to: `/aluguel/relatorio/logistico`,
          requiredPermission: 'Listar relatórios',
        },
        {
          name: 'Manutenção',
          icon: faToolbox,
          to: `/aluguel/relatorio/manutencao`,
          requiredPermission: 'Listar relatórios',
        },
        {
          name: 'Produção',
          icon: faPieChart,
          to: `/aluguel/relatorio/producao`,
          requiredPermission: 'Listar relatórios',
        },
      ],
    },
  ]
}
